var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-map"},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isLoading}}),_c('div',{staticClass:"map-image",staticStyle:{"min-height":"400px"},attrs:{"id":'map-image-' + _vm.data.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }